import type { SeverityDto } from '@internal/scorecards-common';

export interface SeverityDisplay {
  label: string;
  /** Border/bar fill color. */
  colorVar: string;
  /** Outlined badge background. */
  bgVar: string;
  /** Readable text on top of bgVar. */
  fgVar: string;
}

/**
 * CSS-token display properties derived from a severity DTO. Tokens live in tokens.css.
 *
 * Severity IDs are a styling contract: each ID must have matching --zf-sc-sev-${id} tokens.
 * If a new severity is added to sc_severities, its CSS tokens must be added to tokens.css too.
 * Unknown IDs fall back to neutral colours so badges remain visible rather than invisible.
 */
export function severityDisplay(sv: SeverityDto): SeverityDisplay {
  return {
    label: sv.label,
    colorVar: `var(--zf-sc-sev-${sv.id}, var(--bui-fg-secondary))`,
    bgVar: `var(--zf-sc-sev-${sv.id}-bg, var(--bui-bg-neutral))`,
    fgVar: `var(--zf-sc-sev-${sv.id}-fg, var(--bui-fg-primary))`,
  };
}

/** Rank from API-sourced severities. Unknown values sort last (9999). */
export function severityRank(
  s: string | undefined,
  severities: SeverityDto[],
): number {
  return severities.find(sv => sv.id === s)?.rank ?? 9999;
}

export const PASSING_DISPLAY = {
  label: 'Passing',
  colorVar: 'var(--zf-sc-pass)',
};
